// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Loader__Loader--2z84Y","lds-spinner":"Loader__lds-spinner--1m1HW","center":"Loader__center--393dJ"};